<template>
  <div class="step-one">
    <section
      v-if="showConfirm"
      class="modal modal-result"
      @click="showConfirm = false"
    >
      <div class="confirm-box" @click.stop>
        <p>需要在芒果TVapp内才能参与招募！</p>
        <div class="btn-normal" @click="onJump">前往芒果TV</div>
      </div>
    </section>
    <div class="main">
      <div class="icon icon-logo2"></div>
      <p class="sub-title">芒果TV自制原创声音互动陪伴类真人秀节目</p>
      <p class="main-title">《朋友请听好》第二季故事招募</p>
      <div class="video-section" ref="videoWrapper"></div>
      <p class="main-title">故事，拿来吧你！</p>
      <p class="sub-title">参与报名，就有机会和“广播小站”进行电话互动哦！</p>
      <div class="btn-wrapper">
        <div class="btn btn-item" @click="onClickBtn">
          参与故事招募
          <div class="icon icon-line3 abs"></div>
        </div>
        <div class="icon icon-cat abs"></div>
      </div>
      <div class="">
        <p>活动时间：2021年8月——2021年12月</p>
        <p>参与节目报名通通免费！千万不要上当受骗哦！</p>
      </div>
    </div>
  </div>
</template>

<script>
import Env from "@/utils/env";
import { wakeupApp } from "@/utils/common";
import ZTMobilePlayer from 'ztplayer-mobile';

export default {
  data() {
    return {
      showConfirm: false,
      player:null
    };
  },
  methods: {
    initPlayer() {
      this.player = new ZTMobilePlayer({
        wrapper: this.$refs.videoWrapper,
        controls: true,
        fullscreen: false,
        controltype: 1
      });
      this.player.fetchVideoInfo(13872458);
    },
    onJump() {
      setTimeout(() => {
        this.showConfirm = false;
        let scheme = `imgotv://webview?url=${encodeURIComponent(
          window.location.href
        )}`;
        let url = `https://a.app.qq.com/o/simple.jsp?pkgname=com.hunantv.imgo.activity&ios_scheme=${encodeURIComponent(
          scheme
        )}&android_schema=${encodeURIComponent(scheme)}`;
        if (Env.isIOS) {
          url = `https://msite.api.mgtv.com/download.html?type=2&content=${encodeURIComponent(
            scheme
          )}`;
          scheme = url;
        }
        wakeupApp(url, scheme);
      }, 500);
    },
    onClickBtn() {
      if (!Env.isMgtvApp && !this.isDev) {
        this.showConfirm = true;

        return;
      } else {
        this.$emit("next");
      }
    }
  },
  mounted() {
    this.initPlayer()
  }
};
</script>

<style lang="scss">
@import "~@/assets/mixins.scss";

.step-one {
  video {
    object-fit: cover !important;
  }
  .confirm-box {
    background-image: url("~@/assets/img/confirm.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(font-size, 34);
    @include px2vw(padding-top, 55);
    text-align: center;
    p {
      font-weight: 500;
    }
    .btn-normal {
      @include px2vw(margin-top, 57);
    }
  }
  .video-section {
    @include px2vw(width, 590);
    @include px2vw(height, 331.8);
    margin: 0 auto;
    background: #d8d8d8;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
  }
  .btn-item {
    position: relative;
    background-image: url("~@/assets/img/btn-2.png");
    @include px2vw(width, 305);
    @include px2vw(height, 85);
    @include px2vw(line-height, 85);
    @include px2vw(font-size, 35);
    font-weight: bold;
    margin: 0 auto;
  }
  .btn-wrapper {
    position: relative;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 85);
  }
  .main {
    @include px2vw(padding-top, 60);
    @include px2vw(width, 690);
    margin: 0 auto;
    color: #333333;
    text-align: center;
    @include px2vw(font-size, 24);
    @include px2vw(line-height, 33);
  }

  .main-title {
    font-weight: 500;
    @include px2vw(line-height, 50);
    @include px2vw(font-size, 36);
  }
  .sub-title {
    font-weight: 500;
    @include px2vw(line-height, 40);
    @include px2vw(font-size, 28);
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 20);
  }

  .icon {
    &-logo2 {
      margin: 0 auto;
    }
    &-cat {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translateY(100%);
    }
    &-line3 {
      @include px2vw(bottom, 0);
      @include px2vw(right, 0);
      transform: translate(50%, 55%);
    }
  }

  .line-wrapper {
    position: relative;
  }
  .pannel {
    &-wrapper {
      @include px2vw(padding-top, 195);
      @include px2vw(line-height, 40);
    }
    &-tip {
      @include px2vw(padding-top, 50);
      @include px2vw(padding-bottom, 75);
      font-weight: 400;
      letter-spacing: 2px;
      text-align: center;
    }
    &-content {
      font-weight: 500;
      text-align: center;
      @include px2vw(line-height, 42);
      @include px2vw(font-size, 30);
      p:first-child {
        @include px2vw(font-size, 34);
        @include px2vw(margin-bottom, 24);
      }
    }
    position: relative;
    background-image: url("~@/assets/img/panel-2.png");
    @include px2vw(width, 610);
    @include px2vw(height, 315);
    @include px2vw(padding-top, 57);
    margin: 0 auto;
    @include px2vw(margin-top, 40);
    @include px2vw(margin-bottom, 40);
  }
}
</style>
